import _ from 'lodash';
import {batch} from 'react-redux';
import {isEqualProtocolsCsvContent} from 'lib/protocolHelper';
import {setTrayData} from 'stores/actions/trayCalibrationStateAction';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {setEStopTriggered, setInstrumentStatus, setMotorErrorData} from 'stores/actions/instrumentAction';
import {invokeAPI, resolveIntl, setErrorCodeNumber} from './commonBusiness';
import {
  showNoRunningProtocolModal,
  showModalMotorCollisionSkipped,
  noLicenseActivatedModal,
  showModalTrayIdPositionNotFound,
  showModalMotorIssueOccurs,
  showSafetyThresholdExceededModal,
} from './modalStateBusinessAction';
import {
  saveProtocol,
  saveRunningProtocol,
  getRunningProtocol,
  openOperatorProtocol,
  clearRunningProtocol,
  openProtocol,
  goToProtocolEditor,
  isProtocolExists,
  NEW_PROTOCOL_ID,
  validateProtocolBeforeRun,
  calculateAndRestoreOpenedProtocolTipCounts,
} from './protocolManagementBusiness';
import {convertCardStateToCsv} from './protocolStateConversionBusiness';
import {isProtocolExecutor, saveState} from './stateBusiness';
import {bindProtocolToTray, isProtocolBoundToTray} from './trayBusiness';
import {changeView, showLoading, hideLoading, showSnackbar} from '../actions/appStateAction';
import {
  resetCardState,
  resetGroupState,
  restoreCardState,
  restoreCardTaskState,
  restoreGroupState,
  setGroupIsAllExpanded,
} from '../actions/cardStateAction';
import {restoreLabwareState} from '../actions/labwareStateAction';
import {showModal, hideModal, clearPreviousErrorModal} from '../actions/modalStateAction';
import {
  setRuntimeProtocolId,
  setRuntimeProtocolName,
  setRuntimeStatus,
  restoreRuntimeState,
  resetRuntimeState,
  setRuntimeRemainingTime,
  setRuntimeUser,
  hideRuntimeDialog,
  setRuntimeIsTessaraProtocol,
  setRuntimeAbortRequester,
  setRuntimeType,
  setExecutionCount,
  setRuntimePauseRemainingTime,
  setRuntimeTrayType,
} from '../actions/runtimeStateAction';
import {setLastOpenedProtocol, setTemporaryUnsavedProtocolData} from '../actions/protocolAction';
import {
  SignalRHub,
  SignalREvent,
  FastRobotErrorcode,
  ViewMode,
  RuntimeMode,
  TaskType,
  RuntimeNotificationType,
  SetTrayModalType,
  ModalType,
  TrayType,
  CommonButtonLabel,
  UserRoleLevel,
  ExecutionStatus,
  CardType,
  RuntimeType,
  LastExecEnum,
  TaskDelayUnit,
  ServiceResponseCode,
  TrayTypeKey,
  TipCaddyType,
  InstrumentStatusType,
} from '../../constants/dataEnum';
import {checkTessaraUser, isRoleLevel, isUserOperator} from './userManagementBusiness';
import {removeUnusedPicklistBarcode} from './taskListPicklistBusiness';
import {setWizardFlag} from '../actions/wizardStateAction';
import {abortActionBatch, resumeProtocol, setTrayId} from './instrumentBusiness';
import {
  abortPauseResponseHandler,
  resumeResponseHandler,
  showAbnormalYawDetectedModal,
  showDelayModal,
  showImpossibleConsolidateTipsModal,
  showImpossibleLabwarePosModal,
  showInvalidASpirateDispenseVolumeSumModal,
  showInvalidCaddyConditionConsolidateTips,
  showModalEjectToCaddyFallenTipsDetected,
  showModalHeadBrokenTips,
  showModalImposiblePickUpPosition,
  showModalNeedEmptyWasteCaddyAndRefillTipCaddy,
  showModalNeedInsertEmptyWasteCaddy,
  showModalPickTipCaddyCollideWithWasteCaddy,
  showModalRunningOutTips,
  showModalScanFailed,
  showModalTipsNotEnoughPartiallyUnReachable,
  showModalUnsupportedTipPickUpPosition,
  showModalWasteCaddyEjectPositionNotAvailable,
  showPlatePosSuggestionAvailableModal,
  showRearrangeTipModal,
  showRunningProtocolWillTakeMoreTime,
  showRuntimeAbortedModal,
  showRuntimeErrorBarcodeModal,
  showRuntimeFinishedModal,
  showRuntimeMissingTrayModal,
  showRuntimePausedModal,
  showRuntimePlatePosSuggestionAvailableModal,
  showTipsNotEnoughPartiallyModal,
  showTipsNotEnoughPartiallyYouHaveNoChoiceModal,
  showUnknownPlateId,
  showUnsupportedLabwareModal,
  showUserConfirmationModal,
  showVisionErrorModal,
} from './runtimeModalBusiness';
import jsonCopy from '../../lib/jsonCopy';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import {
  showDefaultErrorModal,
  showFormattedModal,
  showIsBusyModal,
  showModalConnectionFailed,
  showModalDetectHardwareChange,
  showModalMisalignedTray,
  showModalUnsupportedTray,
} from './commonModalBusiness';
import {gettingAndSetInstalledTray} from './trayCalibrationBusiness';
import {showModalSetTrayID} from '../actions/modalSetTrayIDStateAction';
// eslint-disable-next-line import/no-cycle
import {showEmergencyStopModal} from './emergencyStopBusiness';
// eslint-disable-next-line import/no-cycle
import {fastRecovery} from './recoveryBusiness';
import {SetupWizardStep, WizardFlag} from '../../constants/SetupWizardEnum';
import {convertCsvToCardState} from './protocolCSVConversionBusiness';
import {modifyObjectValue} from '../../lib/objectHelper';
import {removeTemporaryState} from '../actions/temporaryStateAction';
import {DISPENSE_REPORT_NOTIFICATION} from '../../constants/temporaryStateType';
import {fetchProtocolById, getProtocolByIdAndUserId} from '../../api/protocolManagementApi';
import {fetchAndDownloadLatestDispenseReport} from './reportStateBusiness';
import {handleTrialCountdownNotification, checkLicenseValidity} from './licenseBusiness';
import {setProtocolStateRunningProtocol} from '../actions/protocolExplorerAction';
import {handleDefaultWizardAPICallResponse} from './setupWizardBusiness/setupWizardInstrumentBusiness';
import {
  clearInstrumentProcess,
  getInstrumentStatusDoubleCheck,
  isV2Instrument,
  setInstrumentProcess,
} from './instrumentStatusBusiness';
import {isConsolidateTipsCardExist} from '../../lib/cardAndTaskHelper';
import {showModalType} from '../actions/typedModalAction';
import {showMissingTrayModal, showTrayUncalibratedModal} from './trayModalBusiness';
import {setStepDataByName} from './setupWizardBusiness/commonSetupWizardBusiness';
import {showLoadCellErrorModal} from './loadCellErrorBusiness';
import {isLoadCellError} from './errorHandlerBusiness';
import {openTrayCalibrationPage} from './menuBusiness';
import {handleIncompatibleVisionVersionError} from './plateRecognitionBusiness';

const intl = resolveIntl();

export const runApiResponseHandler =
  (
    fastErrorCode,
    // eslint-disable-next-line default-param-last
    payload = [],
    protocol,
  ) =>
  async (dispatch, getState) => {
    const {appState} = getState();

    await dispatch(setErrorCodeNumber(fastErrorCode));

    if (appState.viewMode === ViewMode.SETUP_WIZARD) {
      dispatch(setWizardFlag(WizardFlag.ERROR));
      dispatch(setStepDataByName(SetupWizardStep.PLATE_COPY_PROTOCOL, {isSkippable: true, isStepProcessed: false}));
    }
    dispatch(hideLoading());
    console.log('runApiResponseHandler', fastErrorCode);

    switch (fastErrorCode) {
      case FastRobotErrorcode.TrayUncalibrated: {
        const calibrateTrayCallback = () => dispatch(openTrayCalibrationPage());

        dispatch(showTrayUncalibratedModal(calibrateTrayCallback));
        break;
      }
      case FastRobotErrorcode.InvalidTrayID: {
        dispatch(showModalSetTrayID(SetTrayModalType.PROTOCOL_EDITOR));
        break;
      }
      case FastRobotErrorcode.MissingTray: {
        dispatch(showMissingTrayModal());
        break;
      }
      case FastRobotErrorcode.Busy: {
        const runningProtocolResponse = await dispatch(getRunningProtocol());
        const {username} = runningProtocolResponse?.payload?.user || {};
        dispatch(showIsBusyModal(username));
        break;
      }
      case FastRobotErrorcode.ImpossibleLabwarePos: {
        dispatch(showImpossibleLabwarePosModal());
        break;
      }
      case FastRobotErrorcode.PlatePosSuggestionAvailable: {
        dispatch(showPlatePosSuggestionAvailableModal(payload));
        break;
      }
      case FastRobotErrorcode.INVALID_ASPIRATE_DISPENSE_VOLUME_SUM: {
        dispatch(showInvalidASpirateDispenseVolumeSumModal());
        break;
      }
      case FastRobotErrorcode.ActuatorEmergencyStop: {
        dispatch(setEStopTriggered(true));
        dispatch(showEmergencyStopModal(fastRecovery, payload));
        break;
      }
      case FastRobotErrorcode.UNKNOWN_PLATE_ID: {
        dispatch(showUnknownPlateId());
        break;
      }
      case FastRobotErrorcode.NO_LICENSE_ACTIVATED: {
        dispatch(noLicenseActivatedModal());
        break;
      }
      case FastRobotErrorcode.ActuatorEncoderError:
      case FastRobotErrorcode.ActuatorFollowingErrorIdle:
      case FastRobotErrorcode.ActuatorFollowingErrorMoving:
      case FastRobotErrorcode.ActuatorNotReady:
      case FastRobotErrorcode.ActuatorUnexpectedTrigger:
      case FastRobotErrorcode.ActuatorAborted:
      case FastRobotErrorcode.NotReady: {
        dispatch(
          showModalMotorCollisionSkipped(async () => {
            dispatch(showLoading(intl.formatMessage({id: 'recoveryAction.loading'})));
            await dispatch(fastRecovery());
            dispatch(hideLoading());
          }),
        );
        break;
      }
      case FastRobotErrorcode.HEAD_BROKEN_TIPS:
        dispatch(showModalHeadBrokenTips());
        break;
      case FastRobotErrorcode.NO_TRAY_ID_FOUND:
        dispatch(showModalSetTrayID(SetTrayModalType.PROTOCOL_EDITOR));
        break;
      case FastRobotErrorcode.A1_OFFSET_UNFIT: {
        dispatch(showSafetyThresholdExceededModal());
        break;
      }
      case FastRobotErrorcode.INCOMPATIBLE_VISION_VERSION: {
        dispatch(handleIncompatibleVisionVersionError());
        break;
      }
      case FastRobotErrorcode.MismatchedInstalledTrayAndProtocol: {
        dispatch(showModalUnsupportedTray());
        break;
      }
      case FastRobotErrorcode.MISS_ALIGN_YAW: {
        if (isV2Instrument()) {
          dispatch(showAbnormalYawDetectedModal());
        } else {
          dispatch(showModalDetectHardwareChange());
        }

        break;
      }
      case FastRobotErrorcode.VISION_MULTIPLE_TRAY_ID_FOUND:
      case FastRobotErrorcode.FAILED_TO_COMMUNICATE_WITH_RASPI0:
      case FastRobotErrorcode.BARCODE_SCAN_FAILED:
      case FastRobotErrorcode.BARCODE_NOT_UNIQUE:
      case FastRobotErrorcode.CORAL_NOT_CONNECTED:
      case FastRobotErrorcode.CAMERA_NOT_CONNECTED:
      case FastRobotErrorcode.SSH_CONNECTION_FAILED:
      case FastRobotErrorcode.MIRROR_FIDUCIAL_NOT_FOUND:
      case FastRobotErrorcode.VISION_CALIBRATION_FAILED:
      case FastRobotErrorcode.CORAL_AND_CAMERA_NOT_CONNECTED:
      case FastRobotErrorcode.WRONG_IMAGE_SHAPE:
      case FastRobotErrorcode.WRONG_DETECTION_BOX_DIMENSION:
      case FastRobotErrorcode.WRONG_IMAGE_DETECTION:
      case FastRobotErrorcode.PREDICT_IMAGE_TIMEOUT:
      case FastRobotErrorcode.PREDICT_IMAGE_INVOKE_FAILED:
      case FastRobotErrorcode.DESTINATION_HOST_UNREACHABLE:
      case FastRobotErrorcode.PI0_SERVICE_INACTIVE:
      case FastRobotErrorcode.PI0_SERVICE_FAST_VISION_INACTIVE:
      case FastRobotErrorcode.PI0_SERVICE_SPI2VCAN_INACTIVE:
      case FastRobotErrorcode.CAN_COMMUNICATION_ISSUE:
      case FastRobotErrorcode.FILE_MODEL_DOESNT_EXIST:
      case FastRobotErrorcode.FILE_MODEL_CORRUPTED:
      case FastRobotErrorcode.WRONG_MODEL_IS_USED:
      case FastRobotErrorcode.INVALID_CONFIG_SELECTOR:
      case FastRobotErrorcode.VISION_SERVICE_CRASHES:
      case FastRobotErrorcode.CADDY_NOT_FOUND:
        dispatch(
          showVisionErrorModal(
            'modal.visionDefaultError.title',
            'modal.visionDefaultError.message.idleToRun',
            {errorCode: fastErrorCode},
            true,
          ),
        );
        break;
      case FastRobotErrorcode.UNSUPPORTED_LABWARE: {
        dispatch(showUnsupportedLabwareModal());
        break;
      }
      case FastRobotErrorcode.LOAD_CELL_VALUE_NO_CHANGE:
      case FastRobotErrorcode.LOAD_CELL_DRIVER_FAULT:
      case FastRobotErrorcode.LOAD_CELL_READ_TIMEOUT:
        dispatch(showLoadCellErrorModal(null, fastErrorCode, () => dispatch(executeProtocol(protocol))));
        break;
      default: {
        console.log(
          `%fastCommonRunAPIResponseHandler unmapped fastErrorCode %c${fastErrorCode}!`,
          'color: #FFFFFF; background-color: #FF0000;',
          'color: blue;',
        );
        dispatch(showDefaultErrorModal(fastErrorCode));
        break;
      }
    }
  };

export function fastRuntimeErrorResHandling(response, payload, restoredState = null) {
  return async (dispatch, getState) => {
    if (response === FastRobotErrorcode.WRONG_PLATE_TYPE) {
      const {wrongDetection, trayType} = payload;
      dispatch(showModalType(ModalType.INVALID_PLATE_RECOGNITION, {wrongDetection, trayType}));
      return null;
    }

    const {runtimeState} = getState();

    // NOTE if restoredState (is currently restoring state) copy runtime state
    const tempRuntimeState = restoredState ? jsonCopy(restoredState) : null;
    if (runtimeState.status === RuntimeMode.ABORTING || tempRuntimeState?.status === RuntimeMode.ABORTING) {
      dispatch(await hideLoading());
    }

    const runningProtocolResponse = await dispatch(getRunningProtocol());
    const {payload: runningProtocolPayload} = runningProtocolResponse;
    const isTrayDoubleCaddy = runningProtocolPayload?.trayType === TrayType.DOUBLE_CADDY;

    if (response !== FastRobotErrorcode.NoError) {
      await dispatch(setErrorCodeNumber(response));

      switch (response) {
        case FastRobotErrorcode.VISION_NOT_CONFIDENT:
        case FastRobotErrorcode.CADDY_NOT_EXIST:
        case FastRobotErrorcode.FAILED_TO_CALCULATE_TIPS:
        case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_MANUAL_ARRAGEMENT:
        case FastRobotErrorcode.TIPS_REARRANGEMENT_UNSUPPORTED:
        case FastRobotErrorcode.TipsNotEnough:
        case FastRobotErrorcode.TipsNeedArrangement:
        case FastRobotErrorcode.TipsNotEnoughPartially:
        case FastRobotErrorcode.TipsNotEnoughPartiallyYouHaveNoChoice:
        case FastRobotErrorcode.TIPS_NOT_ENOUGH_PARTIALLY_UNREACHABLE:
        case FastRobotErrorcode.FALLEN_TIPS_DETECTED:
        case FastRobotErrorcode.STUCK_TIPS_DETECTED:
        case FastRobotErrorcode.SLANTED_TIPS_DETECTED:
        case FastRobotErrorcode.FALLEN_AND_SLANTED_TIPS_DETECTED:
        case FastRobotErrorcode.MIRROR_DIRTY:
        case FastRobotErrorcode.MIRROR_NOT_FOUND:
        case FastRobotErrorcode.CADDY_TYPE_MISMATCHED: {
          const isExecutor = await dispatch(isProtocolExecutor());

          if (!isExecutor) {
            return null;
          }

          break;
        }
        default:
          break;
      }

      switch (response) {
        case FastRobotErrorcode.NotReady:
        case FastRobotErrorcode.ActuatorFollowingErrorMoving:
        case FastRobotErrorcode.ActuatorFollowingErrorIdle:
        case FastRobotErrorcode.ActuatorNotReady:
        case FastRobotErrorcode.ActuatorAbortedEnterWell:
        case FastRobotErrorcode.ActuatorAborted: {
          const {needSecondRecovery} = payload;

          const isCollision =
            response === FastRobotErrorcode.ActuatorNotReady ||
            response === FastRobotErrorcode.ActuatorAbortedEnterWell ||
            response === FastRobotErrorcode.ActuatorAborted;

          if (isCollision) {
            if (!restoredState) {
              // NOTE if not restoredState dispatch action
              dispatch(setRuntimeStatus(RuntimeMode.ERROR_ABORT_MOTOR_COLLISION_SKIP));
            } else {
              // NOTE if restoredState (is currently restoring state) modfy tempRuntimeState
              tempRuntimeState.status = RuntimeMode.ERROR_ABORT_MOTOR_COLLISION_SKIP;
            }
          } else {
            // eslint-disable-next-line no-lonely-if
            if (!restoredState) {
              // NOTE if not restoredState dispatch action
              dispatch(setRuntimeStatus(RuntimeMode.ERROR_ABORT_MOTOR_SKIP));
            } else {
              // NOTE if restoredState (is currently restoring state) modfy tempRuntimeState
              tempRuntimeState.status = RuntimeMode.ERROR_ABORT_MOTOR_SKIP;
            }
          }

          const callback = async (mustReleaseTip = false) => {
            if (needSecondRecovery) {
              dispatch(showLoading(intl.formatMessage({id: 'recoveryAction.loading'})));
              dispatch(setMotorErrorData({mustReleaseTip}));
              await dispatch(resumeProtocol(false, false, false));
              dispatch(hideLoading());
            } else {
              dispatch(resumeResponseHandler(mustReleaseTip));
            }
          };

          const {status} = runtimeState;
          dispatch(
            showModalMotorCollisionSkipped(callback, () => {
              if (status === RuntimeMode.ERROR_MISSING_TRAY) {
                dispatch(abortActionBatch());
              } else {
                dispatch(
                  abortPauseResponseHandler(null, () => {
                    dispatch(fastRuntimeErrorResHandling(response, payload, restoredState));
                  }),
                );
              }
            }),
          );
          break;
        }
        case FastRobotErrorcode.VISION_NOT_CONFIDENT:
        case FastRobotErrorcode.CADDY_NOT_EXIST:
        case FastRobotErrorcode.FAILED_TO_CALCULATE_TIPS: {
          dispatch(showModalScanFailed(response));
          break;
        }
        case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_REMOVE_DECK_1:
        case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_REMOVE_DECK_1_NOT_ENOUGH_TIPS_DECK_2:
        case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_MOVE_CADDY_TO_OTHER_DECK:
        case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_MANUAL_ARRAGEMENT: {
          dispatch(showModalImposiblePickUpPosition(response, isTrayDoubleCaddy));
          break;
        }
        case FastRobotErrorcode.TIPS_REARRANGEMENT_UNSUPPORTED: {
          dispatch(showModalUnsupportedTipPickUpPosition());
          break;
        }
        case FastRobotErrorcode.TipsNotEnough: {
          const {requiredTips} = payload;
          dispatch(showModalRunningOutTips(requiredTips));
          if (!restoredState) {
            dispatch(setRuntimeStatus(InstrumentStatusType.PAUSED));
            dispatch(setInstrumentStatus(InstrumentStatusType.PAUSED));
          } else {
            // NOTE if restoredState (is currently restoring state) modfy tempRuntimeState
            tempRuntimeState.status = RuntimeMode.PAUSED;
            // tempRuntimeState.dialog = dialog;
            return tempRuntimeState;
          }
          break;
        }
        case FastRobotErrorcode.TipsNeedArrangement: {
          dispatch(hideLoading());
          dispatch(showRearrangeTipModal());
          break;
        }
        case FastRobotErrorcode.TipsNotEnoughPartiallyYouHaveNoChoice: {
          const {requiredTips, availableTips} = payload;
          dispatch(hideLoading());
          dispatch(showTipsNotEnoughPartiallyYouHaveNoChoiceModal(requiredTips, availableTips));
          break;
        }
        case FastRobotErrorcode.TipsNotEnoughPartially: {
          const {availableTips, requiredTips} = payload;
          dispatch(hideLoading());
          dispatch(showTipsNotEnoughPartiallyModal(requiredTips, availableTips));
          break;
        }
        case FastRobotErrorcode.TIPS_NOT_ENOUGH_PARTIALLY_UNREACHABLE: {
          dispatch(showModalTipsNotEnoughPartiallyUnReachable());
          break;
        }
        case FastRobotErrorcode.NEED_INSERT_EMPTY_WASTE_CADDY: {
          dispatch(showModalNeedInsertEmptyWasteCaddy());
          break;
        }
        case FastRobotErrorcode.NEED_EMPTY_WASTE_CADDY_AND_REFILL_TIP_CADDY: {
          dispatch(showModalNeedEmptyWasteCaddyAndRefillTipCaddy());
          break;
        }
        case FastRobotErrorcode.PICK_TIP_CADDY_COLLIDE_WITH_WASTE_CADDY: {
          dispatch(showModalPickTipCaddyCollideWithWasteCaddy());
          break;
        }
        case FastRobotErrorcode.EJECT_TO_CADDY_FALLEN_TIPS_DETECTED: {
          dispatch(showModalEjectToCaddyFallenTipsDetected());
          break;
        }
        case FastRobotErrorcode.WASTE_CADDY_EJECT_POSITION_NOT_AVAILABLE: {
          dispatch(showModalWasteCaddyEjectPositionNotAvailable());
          break;
        }
        case FastRobotErrorcode.MissingTray: {
          dispatch(setRuntimeStatus(RuntimeMode.ERROR_MISSING_TRAY));
          dispatch(
            showRuntimeMissingTrayModal(() => {
              dispatch(abortActionBatch());
            }),
          );
          // if (!restoredState) {
          //   dispatch(setRuntimeStatus(RuntimeMode.ERROR_MISSING_TRAY));
          //   dispatch(showRuntimeDialog(dialog));
          //   break;
          // } else {
          //   // NOTE if restoredState (is currently restoring state) modfy tempRuntimeState
          //   tempRuntimeState.status = RuntimeMode.ERROR_MISSING_TRAY;
          //   tempRuntimeState.dialog = dialog;
          //   return tempRuntimeState;
          // }
          break;
        }
        case FastRobotErrorcode.MISALIGNMENT_TRAY: {
          dispatch(
            showModalMisalignedTray(() => {
              dispatch(openTrayCalibrationPage());
            }),
          );
          break;
        }
        case FastRobotErrorcode.MISS_ALIGN_YAW: {
          if (isV2Instrument()) {
            dispatch(showAbnormalYawDetectedModal());
          } else {
            dispatch(showModalDetectHardwareChange());
          }

          break;
        }
        case FastRobotErrorcode.FALLEN_TIPS_DETECTED:
          dispatch(showVisionErrorModal('modal.tipFallen.title', 'modal.tipFallen.message'));
          break;
        case FastRobotErrorcode.STUCK_TIPS_DETECTED:
          dispatch(showVisionErrorModal('modal.tipStuck.title', 'modal.tipStuck.message'));
          break;
        case FastRobotErrorcode.SLANTED_TIPS_DETECTED:
          dispatch(showVisionErrorModal('modal.tipSlanted.title', 'modal.tipSlanted.message'));
          break;
        case FastRobotErrorcode.FALLEN_AND_SLANTED_TIPS_DETECTED:
          dispatch(showVisionErrorModal('modal.tipFallenAndSlanted.title', 'modal.tipFallenAndSlanted.message'));
          break;
        case FastRobotErrorcode.MIRROR_DIRTY:
          dispatch(showVisionErrorModal('modal.mirrorDirty.title', 'modal.mirrorDirty.message'));
          break;
        case FastRobotErrorcode.MIRROR_NOT_FOUND:
          dispatch(showVisionErrorModal('modal.mirrorNotFound.title', 'modal.mirrorNotFound.message'));
          break;
        case FastRobotErrorcode.CADDY_NOT_FOUND: {
          const runtimeType = dispatch(checkRuntimeType(runningProtocolPayload));

          if (runtimeType === RuntimeType.CONSOLIDATE_TIPS) {
            dispatch(showInvalidCaddyConditionConsolidateTips(response));
          } else {
            dispatch(
              showVisionErrorModal(
                'modal.caddyNotFound.title',
                `modal.caddyNotFound${isTrayDoubleCaddy ? 'DoubleCaddy' : ''}.message`,
              ),
            );
          }
          break;
        }
        case FastRobotErrorcode.INCOMPATIBLE_VISION_VERSION: {
          dispatch(handleIncompatibleVisionVersionError());
          break;
        }
        case FastRobotErrorcode.VISION_MULTIPLE_TRAY_ID_FOUND:
        case FastRobotErrorcode.FAILED_TO_COMMUNICATE_WITH_RASPI0:
        case FastRobotErrorcode.BARCODE_SCAN_FAILED:
        case FastRobotErrorcode.BARCODE_NOT_UNIQUE:
        case FastRobotErrorcode.CORAL_NOT_CONNECTED:
        case FastRobotErrorcode.CAMERA_NOT_CONNECTED:
        case FastRobotErrorcode.SSH_CONNECTION_FAILED:
        case FastRobotErrorcode.MIRROR_FIDUCIAL_NOT_FOUND:
        case FastRobotErrorcode.VISION_CALIBRATION_FAILED:
        case FastRobotErrorcode.CORAL_AND_CAMERA_NOT_CONNECTED:
        case FastRobotErrorcode.WRONG_IMAGE_SHAPE:
        case FastRobotErrorcode.WRONG_DETECTION_BOX_DIMENSION:
        case FastRobotErrorcode.WRONG_IMAGE_DETECTION:
        case FastRobotErrorcode.PREDICT_IMAGE_TIMEOUT:
        case FastRobotErrorcode.PREDICT_IMAGE_INVOKE_FAILED:
        case FastRobotErrorcode.DESTINATION_HOST_UNREACHABLE:
        case FastRobotErrorcode.PI0_SERVICE_INACTIVE:
        case FastRobotErrorcode.PI0_SERVICE_FAST_VISION_INACTIVE:
        case FastRobotErrorcode.PI0_SERVICE_SPI2VCAN_INACTIVE:
        case FastRobotErrorcode.CAN_COMMUNICATION_ISSUE:
        case FastRobotErrorcode.FILE_MODEL_DOESNT_EXIST:
        case FastRobotErrorcode.FILE_MODEL_CORRUPTED:
        case FastRobotErrorcode.WRONG_MODEL_IS_USED:
        case FastRobotErrorcode.INVALID_CONFIG_SELECTOR:
        case FastRobotErrorcode.VISION_SERVICE_CRASHES:
        case FastRobotErrorcode.IN_CORAL_LESS_MODE:
          dispatch(
            showVisionErrorModal('modal.visionDefaultError.title', 'modal.visionDefaultError.message', {
              errorCode: response,
            }),
          );
          break;
        case FastRobotErrorcode.CADDY_TYPE_MISMATCHED: {
          const {trayType, mismatchedNestIds = []} = payload;

          dispatch(
            showModalType(ModalType.CADDY_DETECTION, {
              trayType,
              firstNestLocation: mismatchedNestIds[0],
              secondNestLocation: mismatchedNestIds[1],
              expectedCaddy:
                trayType === TrayType.HIGH_VOLUME_CADDY
                  ? TipCaddyType.HIGH_VOLUME_CADDY
                  : TipCaddyType.LOW_VOLUME_CADDY,
            }),
          );
          break;
        }
        case FastRobotErrorcode.ActuatorEmergencyStop: {
          dispatch(showEmergencyStopModal(fastRecovery, true));
          break;
        }
        case FastRobotErrorcode.NO_LICENSE_ACTIVATED: {
          dispatch(noLicenseActivatedModal());
          break;
        }
        case FastRobotErrorcode.REQUIRED_BARCODE_NOT_FOUND: {
          const {barcodeNotFound, unknownBarcode} = payload;

          dispatch(showRuntimeErrorBarcodeModal(barcodeNotFound, unknownBarcode));
          break;
        }
        case FastRobotErrorcode.PLATE_POS_SUGGESTION_AVAILABLE: {
          const {platePosSuggestions} = payload;
          dispatch(showRuntimePlatePosSuggestionAvailableModal(platePosSuggestions));
          break;
        }
        case FastRobotErrorcode.NO_TRAY_ID_FOUND:
          dispatch(showModalSetTrayID(SetTrayModalType.PROTOCOL_EDITOR));
          break;
        case FastRobotErrorcode.TRAY_ID_POSITION_NOT_FOUND:
          dispatch(
            showModalTrayIdPositionNotFound(
              () => dispatch(resumeProtocol(false, false, true)),
              () => dispatch(abortActionBatch()),
            ),
          );
          break;
        case FastRobotErrorcode.ActuatorWaitMotionTimeout: {
          const {lastExecutedTask} = payload;
          dispatch(
            showModalMotorIssueOccurs(
              response,
              () => dispatch(resumeProtocol(false, false, true)),
              () =>
                dispatch(
                  abortPauseResponseHandler(lastExecutedTask, () => {
                    dispatch(fastRuntimeErrorResHandling(response, payload, restoredState));
                  }),
                ),
            ),
          );
          break;
        }
        case FastRobotErrorcode.CONSOLIDATE_TIPS_TASK_CONTAINS_INVALID_CADDIES_COUNT:
        case FastRobotErrorcode.CONSOLIDATE_TIPS_TASK_NO_CADDY_1:
        case FastRobotErrorcode.CONSOLIDATE_TIPS_TASK_NO_CADDY_2:
          dispatch(showInvalidCaddyConditionConsolidateTips(response));
          break;
        case FastRobotErrorcode.LOAD_CELL_VALUE_NO_CHANGE:
        case FastRobotErrorcode.LOAD_CELL_DRIVER_FAULT:
        case FastRobotErrorcode.LOAD_CELL_READ_TIMEOUT: {
          const {needSecondRecovery} = payload;
          const callback = async (mustReleaseTip = false) => {
            if (needSecondRecovery) {
              dispatch(showLoading(intl.formatMessage({id: 'recoveryAction.loading'})));
              const resp = await dispatch(resumeProtocol(false, false, false));
              dispatch(hideLoading());
              if (resp.errorCode === FastRobotErrorcode.NoError) {
                dispatch(resumeResponseHandler(mustReleaseTip));
                dispatch(setRuntimePauseRemainingTime(false));
              } else if (isLoadCellError(resp.errorCode)) {
                dispatch(showSnackbar('error', intl.formatMessage({id: 'loadCellErrorModal.recover.fail'})));
                dispatch(abortActionBatch());
              } else {
                dispatch(fastRuntimeErrorResHandling(resp.errorCode, payload, restoredState));
              }
            } else {
              dispatch(resumeResponseHandler(mustReleaseTip));
              dispatch(setRuntimePauseRemainingTime(false));
            }
          };
          dispatch(showLoadCellErrorModal(() => dispatch(abortActionBatch()), response, callback, true));
          break;
        }
        default: {
          console.log(
            `%cfastRuntimeErrorResHandling unmapped response %c${response}!`,
            'color: #FFFFFF; background-color: #FF0000;',
            'color: blue;',
          );

          const dialog = {
            type: RuntimeNotificationType.ERROR,
            headerText: (
              <p>
                <FormattedHTMLMessage id="runtimeNotification.allError.headerText" values={{errorCode: response}} />
              </p>
            ),
            bodyText: <FormattedHTMLMessage id="runtimeNotification.defaultError.bodyText" />,
          };
          if (!restoredState) {
            const titleFormat = `runtime.generalError.${response}`;
            const title = intl.formatMessage({id: titleFormat});
            const defaultTitle = intl.formatMessage({id: 'runtime.generalError.defaultTitle'}, {errorCode: response});

            dispatch(setRuntimeStatus(RuntimeMode.ERROR_ABORT));
            dispatch(
              showModal(
                title === titleFormat ? defaultTitle : title,
                <FormattedHTMLMessage id="runtime.generalError.body" />,
                [
                  {
                    className: 'btn-lg',
                    style: 'primary',
                    handlerClick: () => dispatch(hideModal()),
                    text: intl.formatMessage({id: 'runtime.generalError.button'}),
                  },
                ],
                () => dispatch(hideModal()),
              ),
            );
            break;
          } else {
            // NOTE if restoredState (is currently restoring state) modfy tempRuntimeState
            tempRuntimeState.status = RuntimeMode.ERROR_ABORT;
            tempRuntimeState.dialog = dialog;
            return tempRuntimeState;
          }
        }
      }
    }

    return null;
  };
}

export const closeRuntimeViewHandler = () => async (dispatch, getState) => {
  const state = getState();
  const {protocolEditorState, appState, protocolState, runtimeState, sessionState} = state;

  const {autosave} = protocolEditorState;
  const {prevViewMode, viewMode} = appState;
  const {lastProtocolCheckpoint, lastOpenedProtocol} = protocolState;

  const {protocolName: lastRunName, id: lastRunId, isTessaraProtocol} = runtimeState;
  const {id: lastOpenedId} = lastOpenedProtocol || {};

  const lastProtocolCheckpointId = lastProtocolCheckpoint?.openedProtocol?.id;

  const {user: loggedInUser} = sessionState;
  const isOperator = await dispatch(isUserOperator());

  const isTessaraRegularUser = !dispatch(isRoleLevel(UserRoleLevel.TESSARA_SUPER_USER));
  let {isExecutor, payload: runningProtocolPayload} = await dispatch(isProtocolExecutor(true));

  let runningProtocolResponse = null;
  if (!runningProtocolPayload) {
    runningProtocolResponse = await getProtocolByIdAndUserId(lastRunId, loggedInUser?.userId);
    if (!isExecutor) {
      isExecutor = runtimeState?.userExecutor?.userId === loggedInUser?.userId;
    }
    if (runningProtocolResponse?.code === ServiceResponseCode.OK) {
      runningProtocolPayload = runningProtocolResponse?.payload;
    }
  }

  const isOwner = runningProtocolPayload?.owner === loggedInUser?.userId;
  const lastTimeSameProtocolOpened = lastOpenedId === lastRunId;

  let isProtocolUptoDate = true;

  if (!isOwner && isExecutor && viewMode === ViewMode.RUNTIME) {
    const isProtocolExist = await dispatch(
      isProtocolExists(runningProtocolPayload || {id: lastRunId}, null, runningProtocolResponse),
    );
    if (!isProtocolExist) {
      dispatch(hideLoading());
      return;
    }
  }

  if (viewMode === ViewMode.RUNTIME) {
    if (!isExecutor) {
      dispatch(changeView(ViewMode.EXPLORER));
      dispatch(setLastOpenedProtocol(null));
      dispatch(resetRuntimeState());

      return;
    }

    if (isTessaraProtocol && isTessaraRegularUser) {
      const protocol = await fetchProtocolById(lastOpenedId);

      // check if tessara protocol has been deleted by the super user,
      // or if the tessara protocol have been converted to regular protocol
      if (!protocol || !protocol?.isTessaraProtocol) {
        dispatch(hideRuntimeDialog());
        dispatch(changeView(ViewMode.EXPLORER));
        return;
      }
    }

    if (!lastTimeSameProtocolOpened) {
      batch(() => {
        dispatch(resetCardState());
        dispatch(resetGroupState());
      });
    }

    if (
      (prevViewMode === ViewMode.PROTOCOL_EDITOR ||
        prevViewMode === ViewMode.TRAY_CALIBRATION ||
        prevViewMode === ViewMode.EXPLORER ||
        prevViewMode === ViewMode.RUNTIME) &&
      lastTimeSameProtocolOpened
    ) {
      // if last view is Set tip then change view to protocol editor, open last run protocol
      if (lastRunName) {
        if (!isOwner) {
          isProtocolUptoDate = await dispatch(
            isProtocolUpToDate(runningProtocolPayload, false, () =>
              setTimeout(() => dispatch(resetRuntimeState()), 200),
            ),
          );
        }

        if (isProtocolUptoDate) {
          if (prevViewMode === ViewMode.EXPLORER) {
            dispatch(changeView(ViewMode.EXPLORER));
          } else {
            showLoading(intl.formatMessage({id: 'explorer.loading.openingProtocol'}));
            await dispatch(openProtocol(lastOpenedProtocol));
            hideLoading();
          }
        }
      } else {
        dispatch(goToProtocolEditor());
      }
    } else if (prevViewMode === ViewMode.PROTOCOL_EDITOR && lastProtocolCheckpointId !== lastRunId && !autosave) {
      dispatch(changeView(ViewMode.EXPLORER));
    } else if (prevViewMode === ViewMode.PROTOCOL_EDITOR && !lastTimeSameProtocolOpened) {
      /*
      Flow conditions: from SQA-
      1. the operator should go to explorer page, if the last session is another protocol and no update pop up
      2. when not operator the executor will be directed to last opened protocol (which is different from runtime protocol,
      because the executor might intend to continue editing/viewing on the last opened protocol),
      and form not executor (that stay in run time even he opens another protocol before then back to run time,
      it will direct to explorer page once the executor closed the run time)
      */
      if (isOperator || !isExecutor) {
        dispatch(changeView(ViewMode.EXPLORER));
      } else {
        showLoading(intl.formatMessage({id: 'explorer.loading.openingProtocol'}));
        await dispatch(goToProtocolEditor());
        hideLoading();
      }
    } else {
      // change to last prevViewMode
      dispatch(changeView(prevViewMode));
    }

    if (isProtocolUptoDate) dispatch(resetRuntimeState());
  }
};

export const getCardExecutionStatus = (card) => (dispatch, getState) => {
  const {runtimeState} = getState();

  if (!card || _.isEmpty(card)) return ExecutionStatus.NONE;

  const {status, csvRecordID, doneRecordCSVIDs} = runtimeState;
  const {tasks} = card;

  if (status === RuntimeMode.ABORTED || !card) {
    return ExecutionStatus.NONE;
  }

  if (card.type === CardType.SERIAL_DILUTION && !tasks.length) {
    return ExecutionStatus.NONE;
  }

  let executionStatus = ExecutionStatus.NONE;
  if (tasks.some((item) => item === csvRecordID)) {
    executionStatus = ExecutionStatus.EXECUTING;
  }

  for (let index = 0; index < tasks.length; index += 1) {
    const taskId = tasks[index];
    if (!doneRecordCSVIDs.some((item) => item === taskId)) {
      return executionStatus;
    }
  }

  return ExecutionStatus.EXECUTED;
};

export const getTaskIdExecutionStatus = (taskId) => (dispatch, getState) => {
  const {runtimeState} = getState();
  const {doneRecordCSVIDs, onProgressRecordCSVIDs} = runtimeState;

  if (doneRecordCSVIDs.some((item) => item === taskId)) {
    return ExecutionStatus.EXECUTED;
  }

  if (onProgressRecordCSVIDs?.includes(taskId)) {
    return ExecutionStatus.EXECUTING;
  }

  return ExecutionStatus.NONE;
};

export const expandExecutingCard = (cards) => (dispatch) => {
  const newCards = {...cards};

  Object.values(cards).forEach((card) => {
    const executionStatus = dispatch(getCardExecutionStatus(card));

    if (executionStatus === ExecutionStatus.EXECUTING) {
      newCards[card.ID].isExpanded = true;
      newCards[card.ID].isSelected = true;
    } else {
      newCards[card.ID].isExpanded = false;
      newCards[card.ID].isSelected = false;
    }
  });

  return newCards;
};

export const recoverRunningProtocol = (reportVisible, lastSessionViewMode) => async (dispatch, getState) => {
  const state = getState();
  const {
    appState,
    runtimeState,
    cardState: currentCardState,
    labwareState: currentLabwareState,
    sessionState,
    wizardState,
    protocolState,
    availableLabwareState,
    temporaryState,
  } = state;

  const {viewMode} = appState;

  const statusResponse = await dispatch(getInstrumentStatusDoubleCheck());

  const runningProtocolResponse = await dispatch(getRunningProtocol());
  const isOperator = await dispatch(isUserOperator());

  if (!runningProtocolResponse || runningProtocolResponse.code !== 0 || !runningProtocolResponse.payload) {
    if (viewMode === ViewMode.RUNTIME) {
      if (isOperator) {
        dispatch(openOperatorProtocol());
        return;
      }
      dispatch(changeView(ViewMode.EXPLORER));
      return;
    }

    if (lastSessionViewMode === ViewMode.SETUP_WIZARD) return;

    dispatch(showNoRunningProtocolModal());
    return;
  }

  if (!statusResponse) {
    dispatch(showModalConnectionFailed());
    return;
  }

  const oldProtocol = runningProtocolResponse.payload;
  const protocolId = oldProtocol.id;
  const protocolName = oldProtocol.name;
  const protocolTrayType = oldProtocol.trayType;

  const {isTessaraProtocol, csvContent, cardObject} = oldProtocol || {};

  const oldState = convertCsvToCardState(csvContent, availableLabwareState, cardObject);

  const {labwareState: oldLabwareState} = oldState;
  let {cardState} = oldState;

  const {tasks} = cardState;

  cardState = modifyObjectValue(cardState, 'cards', dispatch(expandExecutingCard(cardState.cards)));

  const taskCount = Object.keys(cardState.tasks).length;

  const {currentState, lastEvent, taskStatuses, percentProgress, remainingTime} = statusResponse;
  const lastTaskStatus = taskStatuses && taskStatuses.length > 0 ? taskStatuses[taskStatuses.length - 1] : null;
  const csvRecordID = lastTaskStatus ? lastTaskStatus.csvRecordID : taskCount - 1;
  const {type} = tasks[csvRecordID] || {};

  const {lastExecutedTask, errorCode: lastErrorCode} = lastEvent?.payload || {};

  const doneRecordCSVIDs = [];
  const onProgressRecordCSVIDs = [];
  let status = RuntimeMode.FINISH;
  let pausedOn = '';

  let isError = false;
  let errorCode;

  if (percentProgress >= 0 && percentProgress < 100) {
    switch (currentState) {
      case 'idle':
        status = RuntimeMode.ABORTED;
        break;
      case 'running':
        status = RuntimeMode.RUNNING;
        break;
      case 'paused':
        if (type === TaskType.DELAY) {
          status = RuntimeMode.RUNNING;
        } else {
          pausedOn = lastExecutedTask;
          errorCode = lastErrorCode;
          status = RuntimeMode.PAUSED;
        }
        break;
      case 'aborted':
        status = RuntimeMode.ABORTED;
        isError = true;
        break;
      default:
        break;
    }
  } else {
    status = RuntimeMode.FINISH;
  }

  if (taskStatuses.length > 1) {
    taskStatuses.forEach((element) => {
      if (element.result) {
        doneRecordCSVIDs.push(element.csvRecordID);
      } else {
        onProgressRecordCSVIDs.push(element.csvRecordID);
      }
    });
  }
  const protocolExecutorUserId = runningProtocolResponse?.payload?.user?.userId;
  const protocolExecutorUser = runningProtocolResponse?.payload?.user;
  const loggedInUserId = sessionState.user.userId;
  const isExecutor = protocolExecutorUserId === loggedInUserId;

  const readOnly = protocolExecutorUserId !== loggedInUserId;

  const newRuntimeState = {
    id: protocolId,
    protocolName,
    csvRecordID,
    doneRecordCSVIDs,
    onProgressRecordCSVIDs,
    progress: percentProgress,
    status,
    pausedOn,
    reportVisible,
    dialog: runtimeState.dialog,
    abortParam: runtimeState.abortParam,
    remainingTime,
    readOnly,
    userExecutor: protocolExecutorUser,
    abortUserRequester: runtimeState.abortUserRequester,
    isTessaraProtocol,
    trayType: protocolTrayType,
    runtimeType: dispatch(checkRuntimeType(oldProtocol)),
  };

  let needToSaveProtocol = false;

  if (
    (Object.values(currentCardState.cards).length > 0 ||
      Object.values(currentCardState.tasks).length > 0 ||
      Object.values(currentLabwareState).find((e) => e.LabwareID)) &&
    viewMode === ViewMode.PROTOCOL_EDITOR
  ) {
    needToSaveProtocol = true;
  }

  batch(async () => {
    if (needToSaveProtocol) {
      await dispatch(saveProtocol(false, false));
    }

    const {autosave} = protocolState;

    // to temporarily store the unsaved protocol before the cardState and labwareState
    // is replaced by the runtime protocol's state
    if (!autosave) {
      dispatch(
        setTemporaryUnsavedProtocolData(
          JSON.stringify({
            cardState: currentCardState,
            labwareState: currentLabwareState,
          }),
        ),
      );
    }

    batch(() => {
      dispatch(restoreLabwareState(oldLabwareState));
      dispatch(restoreCardState(cardState.cards));
      dispatch(restoreCardTaskState(cardState.tasks));
      dispatch(restoreGroupState(cardState.groups));
      dispatch(restoreRuntimeState(newRuntimeState));
      dispatch(setGroupIsAllExpanded());
      dispatch(calculateAndRestoreOpenedProtocolTipCounts());
    });

    if (lastSessionViewMode !== ViewMode.SETUP_WIZARD && lastSessionViewMode !== ViewMode.RUNTIME) {
      dispatch(changeView(ViewMode.RUNTIME));
    }

    if (runtimeState.status === RuntimeMode.ABORTING && protocolExecutorUserId === loggedInUserId) {
      dispatch(showLoading(intl.formatMessage({id: 'instrumentControlHub.AbortProtocolStart.loading'})));
    }

    switch (status) {
      case RuntimeMode.PAUSED:
        if (!errorCode || errorCode === FastRobotErrorcode.NoError) {
          const {messageType} = lastEvent || {};

          const lowerCaseMsgType = messageType?.toLocaleLowerCase();
          const lowerCasePreRunProtocolConfirmationEvent =
            SignalREvent.PRE_RUN_PROTOCOL_CONFIRMATION.toLocaleLowerCase();

          if (lowerCaseMsgType === lowerCasePreRunProtocolConfirmationEvent && isExecutor) {
            dispatch(showRunningProtocolWillTakeMoreTime());
          }
        } else if (
          // these error code are not treated as errors, but as user information that requires action
          // these will be handled on showRuntimeUserActionModalByLastExecutedTask func
          errorCode !== FastRobotErrorcode.FULL_CADDY_DESTINATION &&
          errorCode !== FastRobotErrorcode.EMPTY_CADDY_SOURCE &&
          (errorCode === FastRobotErrorcode.ActuatorEmergencyStop || !readOnly)
        ) {
          const payload = lastEvent?.payload || {};
          dispatch(fastRuntimeErrorResHandling(errorCode, payload));
        }
        break;
      case RuntimeMode.ABORTED:
        if (
          isError &&
          typeof isError === 'string' &&
          (errorCode === FastRobotErrorcode.ActuatorEmergencyStop || !readOnly)
        ) {
          const payload = lastEvent?.payload || {};
          dispatch(fastRuntimeErrorResHandling(isError, payload));
        } else if (lastSessionViewMode !== ViewMode.SETUP_WIZARD) {
          dispatch(showRuntimeAbortedModal(newRuntimeState.abortUserRequester));
        } else if (wizardState.stepName === SetupWizardStep.PLATE_COPY_PROTOCOL) {
          dispatch(setWizardFlag(WizardFlag.ERROR));
          dispatch(setStepDataByName(SetupWizardStep.PLATE_COPY_PROTOCOL, {isSkippable: true, isStepProcessed: false}));
          dispatch(clearRunningProtocol());
        }
        break;
      case RuntimeMode.FINISH:
        if (lastSessionViewMode !== ViewMode.SETUP_WIZARD) {
          dispatch(showRuntimeFinishedModal());
        } else if (wizardState.stepName === SetupWizardStep.PLATE_COPY_PROTOCOL) {
          dispatch(handleDefaultWizardAPICallResponse(true));
          dispatch(clearRunningProtocol());
        }
        break;
      default:
        break;
    }

    const isCheckByLastExecutedTask = type === TaskType.CONSOLIDATE_TIPS;

    if (
      protocolExecutorUserId === loggedInUserId &&
      (status === RuntimeMode.RUNNING || status === RuntimeMode.PAUSED)
    ) {
      if (!lastTaskStatus || isCheckByLastExecutedTask) {
        dispatch(showRuntimeUserActionModalByLastExecutedTask(lastExecutedTask));
      } else {
        const additionalPayload = {delayTime: lastTaskStatus?.remainingDelayTime};
        const payload = {...tasks[csvRecordID], ...additionalPayload};

        const isModalShown = dispatch(showRuntimeUserActionModalByTaskType(type, payload));

        if (!isModalShown && newRuntimeState.runtimeType !== RuntimeType.CONSOLIDATE_TIPS) {
          if (status === RuntimeMode.PAUSED) {
            dispatch(showRuntimePausedModal());
          }
        }
      }
    }

    if (temporaryState?.dispenseReportNotification?.show) {
      dispatch(removeTemporaryState(DISPENSE_REPORT_NOTIFICATION));
    }
    dispatch(saveState());
  });
};

const checkRuntimeType = (protocol) => (dispatch, getState) => {
  const {cardState} = getState();
  const {isTessaraProtocol} = protocol || {};
  const {isTessaraSuperUser, isTessaraRegularUser} = dispatch(checkTessaraUser());

  const cards =
    protocol?.id === NEW_PROTOCOL_ID
      ? cardState.cards
      : protocol?.cardObject?.card || convertCsvToCardState(protocol.csvContent)?.cardState?.cards;

  const isConsolidateTips = isConsolidateTipsCardExist(cards);

  if (isConsolidateTips) return RuntimeType.CONSOLIDATE_TIPS;
  if (isTessaraProtocol) {
    if (isTessaraSuperUser) {
      return RuntimeType.TESSARA_SUPER_USER;
    }

    if (isTessaraRegularUser) {
      return RuntimeType.TESSARA_REGULAR_USER;
    }
  }

  return RuntimeType.NORMAL;
};

const setRunTimeView = (payload, protocol) => (dispatch, getState) => {
  const state = getState();
  const {protocolState, sessionState} = state;
  const {lastOpenedProtocol} = protocolState;
  const {remainingTime} = payload;

  const protocolToRun = protocol || lastOpenedProtocol;
  const {id: protocolId, name: protocolName, isTessaraProtocol, trayType: protocolTrayType} = protocolToRun;

  batch(async () => {
    dispatch(resetRuntimeState());
    dispatch(setRuntimeType(dispatch(checkRuntimeType(protocolToRun))));
    dispatch(setRuntimeRemainingTime(remainingTime));
    await dispatch(setRuntimeStatus(RuntimeMode.RUNNING));
    await dispatch(setInstrumentStatus(InstrumentStatusType.RUNNING));
    await dispatch(changeView(ViewMode.RUNTIME));
    dispatch(setRuntimeProtocolId(protocolId));
    dispatch(setRuntimeTrayType(protocolTrayType));
    dispatch(setRuntimeProtocolName(protocolName));
    dispatch(setRuntimeUser(sessionState?.user));
    dispatch(setRuntimeIsTessaraProtocol(isTessaraProtocol));
    dispatch(setExecutionCount(1));

    dispatch(saveState());
  });
};

export const executeProtocol = (protocol) => async (dispatch, getState) => {
  const {appState, instrumentState} = getState();
  const {viewMode} = appState;
  const {eStopTriggered} = instrumentState;

  if (eStopTriggered) {
    return;
  }

  let csvFromState;

  // generate csv content from state only if the protocol is not being run from setup wizard
  if (!protocol?.csvContent || viewMode !== ViewMode.SETUP_WIZARD) {
    // filter out labware with barcode if there is inactive picklist card
    const labwareState = dispatch(removeUnusedPicklistBarcode(false, false));

    csvFromState = dispatch(convertCardStateToCsv(labwareState));
  } else {
    csvFromState = protocol.csvContent;
  }

  dispatch(
    showLoading(
      intl.formatMessage({
        id: 'runtimeBusiness.scanTip.loading',
      }),
    ),
  );

  const protocolName = protocol?.name || '';

  const runProtocolRes = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.RUN_PROTOCOL, csvFromState, protocolName),
  );

  const {errorCode, payload} = runProtocolRes;

  if (errorCode !== FastRobotErrorcode.NoError) {
    dispatch(hideLoading());
    dispatch(runApiResponseHandler(errorCode, payload, protocol));

    return;
  }

  if (viewMode !== ViewMode.SETUP_WIZARD) {
    await dispatch(setGroupIsAllExpanded());
    await dispatch(setRunTimeView(payload, protocol));
  }

  dispatch(setInstrumentProcess(InstrumentProcessType.PROTOCOL_EXECUTION));
  await dispatch(saveRunningProtocol(protocol));
};

const isProtocolUpToDate =
  (
    protocolTocheck,
    // eslint-disable-next-line default-param-last
    isReRunClick = false,
    callback,
  ) =>
  async (dispatch, getState) => {
    const {protocolState} = getState();
    const {lastOpenedProtocol} = protocolState;

    const updatedProtocol = await fetchProtocolById(protocolTocheck.id);

    if (updatedProtocol) {
      // prevent protocol is updated modal to keep popping up when regular user's labware position is changed
      // due to impossible labware error

      const isProtocolChanged =
        !isEqualProtocolsCsvContent(lastOpenedProtocol?.csvContent, updatedProtocol?.csvContent) ||
        updatedProtocol?.name !== protocolTocheck?.name;

      dispatch(clearPreviousErrorModal());

      if (isProtocolChanged) {
        dispatch(hideLoading());
        dispatch(
          showFormattedModal('protocolEditor.startRunProtocol.protocolUpdated.modal', [
            {
              onClick: async () => {
                await dispatch(openProtocol(updatedProtocol, null, false, false));
                if (callback) callback();
              },
              label: isReRunClick ? CommonButtonLabel.CONFIRM : CommonButtonLabel.GOT_IT,
            },
            isReRunClick && {
              onClick: () => dispatch(hideModal()),
              label: CommonButtonLabel.CANCEL,
            },
          ]),
        );

        return false;
      }
    }

    return true;
  };

export const startRunProtocol =
  (protocol, isReRunClick = false) =>
  async (dispatch, getState) => {
    const state = getState();
    const {protocolState, sessionState, instrumentState} = state;
    const {user: loggedInUser} = sessionState;
    const {isSimulationMode, isAutomationMode, eStopTriggered} = instrumentState;

    const protocolToRun = protocol || protocolState?.lastOpenedProtocol || {};
    const protocolOwnerId = protocolToRun?.owner;

    const isOwner = protocolOwnerId === loggedInUser?.userId;
    const isCheckProtocolUpdates = !isOwner;

    const protocolId = protocolToRun?.id;
    const protocolFolderId = isOwner ? protocolToRun?.folderId || null : null;
    // check for any changes made by other user for the current opened protocol
    if (isCheckProtocolUpdates && protocolId !== NEW_PROTOCOL_ID) {
      const isProtocolExist = await dispatch(isProtocolExists(protocolToRun));

      if (!isProtocolExist) {
        dispatch(hideLoading());
        return;
      }
      const isUpToDate = await dispatch(isProtocolUpToDate(protocolToRun, isReRunClick, null));
      if (!isUpToDate) return;
    }
    if (!isReRunClick) {
      await dispatch(validateProtocolBeforeRun());
    }

    let installedTrayRes = null;

    if (!isAutomationMode && isSimulationMode) {
      const {trayType} = protocolToRun;
      const trayId = TrayTypeKey[trayType];

      installedTrayRes = await dispatch(setTrayId(Number(trayId), trayId));
      dispatch(setTrayData(installedTrayRes));
    } else {
      installedTrayRes = await dispatch(gettingAndSetInstalledTray());
    }

    const trayBarcode = installedTrayRes.tray?.id;

    const protocolBoundToTray = await dispatch(isProtocolBoundToTray(protocolId, protocolFolderId, trayBarcode));

    if (protocolBoundToTray || protocol || protocolId === '-1') {
      await dispatch(executeProtocol(protocolToRun));

      return;
    }
    dispatch(hideLoading());

    // do not execute protocol if estop is triggered
    if (eStopTriggered) {
      return;
    }

    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.firstTimeBindProtocolToTray.title',
        }),
        intl.formatMessage({
          id: 'modal.firstTimeBindProtocolToTray.text',
        }),
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              dispatch(hideModal());
              dispatch(showLoading(intl.formatMessage({id: 'protocolEditor.StartButton.loading'})));
              dispatch(bindProtocolToTray(protocolId, trayBarcode));
              await dispatch(executeProtocol(protocolToRun));
            },
            text: intl.formatMessage({
              id: 'modal.firstTimeBindProtocolToTray.firstButton',
            }),
          },
          {
            className: 'btn-lg',
            style: 'secondary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'modal.firstTimeBindProtocolToTray.secondButton',
            }),
          },
        ],
        () => {
          dispatch(hideModal());
        },
        '',
        false,
      ),
    );
  };

export const onProtocolExecutionDoneInstrumentMoveToIdle = (response) => async (dispatch, getState) => {
  const {appState, modalState, runtimeState} = getState();
  const {viewMode} = appState;

  const isExecutor = await dispatch(isProtocolExecutor());
  const isConsolidateTips = runtimeState.runtimeType === RuntimeType.CONSOLIDATE_TIPS;

  const currentRuntimeStatus = response.aborted ? RuntimeMode.ABORTED : RuntimeMode.FINISH;

  // do not change the runtime status yet for consolidate tips, except when the consolidate tips execution is aborted
  if (!isConsolidateTips || response.aborted) {
    dispatch(setRuntimeStatus(currentRuntimeStatus));
    dispatch(setInstrumentStatus(InstrumentStatusType.OPERATIONAL));
  }

  if (response.abortUsernameRequester && isExecutor) {
    dispatch(setRuntimeAbortRequester(response.abortUsernameRequester));
  }

  if (viewMode === ViewMode.RUNTIME) {
    console.table('ProtocolDone --> dispenseReport', response.dispenseReport);
    console.log('ProtocolDone --> aborted', response.aborted);

    if (modalState.show) dispatch(hideModal());
    dispatch(showLoading(intl.formatMessage({id: 'runtime.movingToIdleLoading'})));
  }
};

export const onProtocolExecutionCompletelyFinished = () => async (dispatch, getState) => {
  const {appState, runtimeState, protocolExplorerState, instrumentState} = getState();
  const {viewMode} = appState;
  const {runningProtocol} = protocolExplorerState;
  const {status, abortUserRequester, runtimeType} = runtimeState;
  const {eStopTriggered} = instrumentState;

  const isExecutor = await dispatch(isProtocolExecutor());
  const isTessaraProtocol =
    runtimeType === RuntimeType.TESSARA_REGULAR_USER || runtimeType === RuntimeType.TESSARA_SUPER_USER;

  // handle downloading dispense report
  dispatch(fetchAndDownloadLatestDispenseReport(true, isTessaraProtocol));

  // show runtime status toast message
  if (status === RuntimeMode.ABORTED) {
    dispatch(showRuntimeAbortedModal(abortUserRequester));
  } else {
    dispatch(setRuntimeStatus(RuntimeMode.FINISH));
    dispatch(showRuntimeFinishedModal());
  }

  // set e-stop triggered flag off because it has been handled on the runtimeError event
  if (eStopTriggered && (viewMode === ViewMode.RUNTIME || viewMode === ViewMode.PROTOCOL_EDITOR)) {
    dispatch(setEStopTriggered(false));
  }

  // handle licensing
  if (viewMode === ViewMode.RUNTIME) {
    dispatch(hideLoading());
    const isValid = await dispatch(checkLicenseValidity());

    if (isValid) {
      dispatch(handleTrialCountdownNotification());
    } else {
      await dispatch(setErrorCodeNumber(FastRobotErrorcode.INVALID_LICENSE_EXPIRED));
      dispatch(noLicenseActivatedModal());
    }
  }

  // handle setup wizard
  if (viewMode === ViewMode.SETUP_WIZARD && isExecutor) {
    if (runtimeState.status === RuntimeMode.ABORTED) {
      dispatch(hideLoading());
    } else {
      const isFinished = runtimeState.status === RuntimeMode.FINISH;
      const handlerOption = {isCallCommonActuatorHandler: false};

      await dispatch(handleDefaultWizardAPICallResponse(isFinished, handlerOption));
    }
  }

  // update running protocol data for explorer
  if (viewMode === ViewMode.EXPLORER && runningProtocol) {
    dispatch(setProtocolStateRunningProtocol(null));
  }

  dispatch(setInstrumentStatus(InstrumentStatusType.OPERATIONAL));
  dispatch(clearInstrumentProcess(true));
  await dispatch(saveState(false));
};

export const showRuntimeUserActionModalByTaskType = (type, payload) => (dispatch) => {
  let doesTaskHaveHandling = true;

  switch (type) {
    case TaskType.USER_CONFIRMATION:
    case TaskType.USER_CONFIRMATION_EJECT: {
      const {message} = payload;

      dispatch(setRuntimeStatus(RuntimeMode.PAUSED));
      dispatch(showUserConfirmationModal(message));
      break;
    }
    case TaskType.DELAY: {
      const {delayTime, delayUnit, message} = payload || {};

      dispatch(
        // minus 1 second for the time to show the modal pop up
        showDelayModal(
          (delayUnit === TaskDelayUnit.MINUTE ? parseInt(delayTime, 10) * 60 : parseInt(delayTime, 10)) - 1,
          message,
        ),
      );
      break;
    }
    default:
      doesTaskHaveHandling = false;
  }

  return doesTaskHaveHandling;
};

export const showRuntimeUserActionModalByLastExecutedTask = (task) => (dispatch) => {
  let doesTaskHaveHandling = true;

  switch (task) {
    case LastExecEnum.CONSOLIDATE_TIPS_EMPTY_SOURCE:
    case LastExecEnum.CONSOLIDATE_TIPS_FULL_DESTINATION: {
      dispatch(hideLoading());
      dispatch(showImpossibleConsolidateTipsModal(task));
      break;
    }
    default:
      doesTaskHaveHandling = false;
  }

  return doesTaskHaveHandling;
};

export function reRunRunningProtocol() {
  return async (dispatch, getState) => {
    const runningProtocol = await dispatch(getRunningProtocol());
    let {payload} = runningProtocol;

    if (!payload) {
      const state = getState();
      const {sessionState, runtimeState, protocolState} = state;
      const {id: runTimeProtocolId} = runtimeState;
      const {lastOpenedProtocol} = protocolState;

      if (runTimeProtocolId && runTimeProtocolId !== lastOpenedProtocol?.id) {
        const {payload: runtimeProtocolPayload} = await getProtocolByIdAndUserId(
          runTimeProtocolId,
          sessionState?.user?.userId,
        );
        payload = runtimeProtocolPayload;
      } else if (lastOpenedProtocol) {
        payload = lastOpenedProtocol;
      }
    }

    dispatch(showLoading(intl.formatMessage({id: 'protocolEditor.StartButton.loading'})));
    await dispatch(startRunProtocol(payload, true));
  };
}
